module.exports = __webpack_public_path__ + "static/media/30OIOS3.1dbe52f8.jpg";